import axios from 'axios';
// import fileDownload from 'js-file-download';

const API_BASE_URL = '/backend/api';

export default {
  namespaced: true,
  state: {
    URLS: {
      LOGIN: `${API_BASE_URL}/user/login`,
      REFRESH_TOKEN: `${API_BASE_URL}/user/refresh`,
      GET_ACCOUNT_INFO: `${API_BASE_URL}/user/me`,

      // Keg
      GET_KEG_LIST: `${API_BASE_URL}/keg/list`,
      CREATE_KEG: `${API_BASE_URL}/keg/create`,
      DELETE_KEG: `${API_BASE_URL}/keg/remove`,
      POST_KEG_RENT: `${API_BASE_URL}/keg/rentTo`,
      POST_KEG_STOCK: `${API_BASE_URL}/keg/returnToStock`,
      POST_KEG_MISSING: `${API_BASE_URL}/keg/kegMissing`,
      POST_KEG_RETIRED: `${API_BASE_URL}/keg/kegRetired`,
      POST_KEG_EDIT_WASHED: `${API_BASE_URL}/keg/kegEditWashed`,
      POST_KEG_EDIT_FILLED: `${API_BASE_URL}/keg/kegEditFilled`,
      POST_KEG_WASHED: `${API_BASE_URL}/keg/kegWashed`,
      POST_KEG_FILLED: `${API_BASE_URL}/keg/kegFilled`,
      GET_KEG_HISTORY: `${API_BASE_URL}/keg/log`,
      GET_KEG_INFO: `${API_BASE_URL}/keg/info`,
      GET_KEG_LOG_EXCEL: `${API_BASE_URL}/keg/logList`,

      // Client
      GET_CLIENT_BY_ID: `${API_BASE_URL}/client/info`,

      // Client
      GET_CLIENT_LIST: `${API_BASE_URL}/client/list`,
      POST_CLIENT_SYNC: `${API_BASE_URL}/client/sync`,

      // Alert Keg
      GET_ALERT_KEG_LIST: `${API_BASE_URL}/alertKeg/list`,
      POST_ALERT_KEG_CREATE: `${API_BASE_URL}/alertKeg/create`,
      POST_ALERT_KEG_DELETE: `${API_BASE_URL}/alertKeg/remove`,

    }
  },
  getters: {
    axiosConfig(state, getters, rootState) {
      return {
        headers: {
          'token': rootState.auth.token,
          'Cache-Control': 'no-cache',
          // 'Content-Type': 'application/json',
        }
      };
    },
    axiosDownloadConfig(state, getters, rootState) {
      return {
        headers: {
          'token': rootState.auth.token,
          // 'Cache-Control': 'no-cache',
          // responseType: 'blob',
          // responseType: 'arraybuffer',
          // 'Content-Type': 'application/json',
        },
        responseType: 'arraybuffer',
      };
    },
  },
  mutations: {

  },
  actions: {
    postApiPromise({getters}, {url, data}) {
      return new Promise(function(resolve, reject) {
        const postData = data? data: {};
        axios.post(url, postData, getters.axiosConfig).then(function(d) {
          if (d.status === 200 && d.data.status === 'ok') {
            resolve(d.data.data);
          } else {
            reject(d.data.reason);
          }
        }).catch(function(e) {
          reject(e);
        });
      });
    },
    postUploadFilePromise({getters}, {url, filename, file}) {
      const formData = new FormData();
      formData.append(filename, file);
      // const axiosConfig = {
      //   headers: {
      //     'token': getters.axiosConfig.headers.token,
      //     'Cache-Control': 'no-cache',
      //     'Content-Type': 'multipart/form-data',
      //   }
      // };
      const axiosConfig = JSON.parse(JSON.stringify(getters.axiosConfig)); //使用深拷貝, 使其不影響其他引用getters.axiosConfig的未知錯誤
      axiosConfig.headers['Content-Type'] = 'multipart/form-data';
      return new Promise(function(resolve, reject) {
        axios.post(url, formData, axiosConfig).then(function(d) {
          if (d.status === 200 && d.data.status === 'ok') {
            resolve(d.data.data);
          } else {
            reject(d.data.reason);
          }
        }).catch(function(e) {
          reject(e);
        });
      });
    },
    getApiPromise({getters}, {url}) {
      return new Promise(function(resolve, reject) {
        axios.get(url, getters.axiosConfig).then(function(d) {
          if (d.status === 200 && d.data.status === 'ok') {
            resolve(d.data.data);
          } else {
            reject(d.data.reason);
          }
        }).catch(function(e) {
          reject(e);
        });
      });
    },
    getAndDownloadPromise({getters}, {url, filename}) {
      return new Promise(function(resolve, reject) {
        axios.get(url, getters.axiosDownloadConfig).then(function(d) {
          const type = d.headers['content-type'];
          const blob = new Blob([d.data], { type: type, encoding: 'UTF-8' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          resolve();
          // fileDownload(d.data, filename);
        }).catch(function(e) {
          reject(e);
        });
      });
    },

    postLoginPromise({dispatch, state}, {email, password}) {
      return dispatch('postApiPromise', {
        url: state.URLS.LOGIN,
        data: {email, password}
      });
    },

    postRefreshTokenPromise({dispatch, state}, token) {
      return dispatch('postApiPromise', {
        url: state.URLS.REFRESH_TOKEN,
        data: {token}
      });
    },

    getAccountInfoPromise({dispatch, state}) {
      return dispatch('getApiPromise', {
        url: state.URLS.GET_ACCOUNT_INFO
      });
    },

    // Keg
    getKegListPromise({dispatch, state}) {
      return dispatch('getApiPromise', {
        url: state.URLS.GET_KEG_LIST
      });
    },

    postCreateKegPromise({dispatch, state}, data) {
      return dispatch('postApiPromise', {
        url: state.URLS.CREATE_KEG,
        data,
      });
    },

    postDeleteKegPromise({dispatch, state}, serial) {
      return dispatch('postApiPromise', {
        url: state.URLS.DELETE_KEG,
        data: {serial},
      });
    },

    postKegRentPromise({dispatch, state}, {kegSerial, clientSerial}) {
      return dispatch('postApiPromise', {
        url: state.URLS.POST_KEG_RENT,
        data: {kegSerial, clientSerial},
      });
    },

    postKegStockPromise({dispatch, state}, {kegSerial}) {
      return dispatch('postApiPromise', {
        url: state.URLS.POST_KEG_STOCK,
        data: {kegSerial},
      });
    },

    postKegMissingPromise({dispatch, state}, {kegSerial}) {
      return dispatch('postApiPromise', {
        url: state.URLS.POST_KEG_MISSING,
        data: {kegSerial},
      });
    },

    postKegRetiredPromise({dispatch, state}, {kegSerial}) {
      return dispatch('postApiPromise', {
        url: state.URLS.POST_KEG_RETIRED,
        data: {kegSerial},
      });
    },

    postKegEditWashedPromise({dispatch, state}, {kegSerial, washed}) {
      return dispatch('postApiPromise', {
        url: state.URLS.POST_KEG_EDIT_WASHED,
        data: {kegSerial, washed},
      });
    },

    postKegEditFilledPromise({dispatch, state}, {kegSerial, filled}) {
      return dispatch('postApiPromise', {
        url: state.URLS.POST_KEG_EDIT_FILLED,
        data: {kegSerial, filled},
      });
    },

    postKegWashedPromise({dispatch, state}, {kegSerial}) {
      return dispatch('postApiPromise', {
        url: state.URLS.POST_KEG_WASHED,
        data: {kegSerial},
      });
    },

    postKegFilledPromise({dispatch, state}, {kegSerial}) {
      return dispatch('postApiPromise', {
        url: state.URLS.POST_KEG_FILLED,
        data: {kegSerial},
      });
    },

    getKegHistoryPromise({dispatch, state}, {kid}) {
      return dispatch('getApiPromise', {
        url: `${state.URLS.GET_KEG_HISTORY}/${encodeURIComponent(kid)}`
      });
    },

    getKegInfoPromise({dispatch, state}, {kid}) {
      return dispatch('getApiPromise', {
        url: `${state.URLS.GET_KEG_INFO}/${encodeURIComponent(kid)}`
      });
    },

    getKegLogExcelPromise({dispatch, state}, {startDate, endDate}) {
      return dispatch('getAndDownloadPromise', {
        url: `${state.URLS.GET_KEG_LOG_EXCEL}?startDate=${startDate}&endDate=${endDate}`,
        filename: 'log.xlsx'
      });
    },
    

    // Client
    getClientByIDPromise({dispatch, state}, {cid}) {
      return dispatch('getApiPromise', {
        url: `${state.URLS.GET_CLIENT_BY_ID}/${cid}`
      });
    },


    
    // Client
    getClientListPromise({dispatch, state}) {
      return dispatch('getApiPromise', {
        url: state.URLS.GET_CLIENT_LIST
      });
    },

    postClientSyncPromise({dispatch, state}, data) {
      return dispatch('postApiPromise', {
        url: state.URLS.POST_CLIENT_SYNC,
        data,
      });
    },

    
    // Alert Keg
    getAlertKegListPromise({dispatch, state}) {
      return dispatch('getApiPromise', {
        url: state.URLS.GET_ALERT_KEG_LIST
      });
    },

    postCreateAlertKegPromise({dispatch, state}, kid) {
      return dispatch('postApiPromise', {
        url: state.URLS.POST_ALERT_KEG_CREATE,
        data: {
          kid
        },
      });
    },

    postDeleteAlertKegPromise({dispatch, state}, serial) {
      return dispatch('postApiPromise', {
        url: state.URLS.POST_ALERT_KEG_DELETE,
        data: {serial},
      });
    },
    
    
    
  },
}
